import { Helmet } from "react-helmet-async";

const BASE = "https://resada.id";

// Per-page SEO meta (title, description, canonical, Open Graph, Twitter, optional JSON-LD).
export default function Seo({
  title,
  description,
  path = "",
  image,
  type = "website",
  jsonLd,
}) {
  const url = BASE + path;
  const img = image || `${BASE}/logo.png`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
